import React, { useEffect, useState} from 'react';
import { Link, useLocation } from 'react-router-dom';
import useScrollPercentage from 'react-scroll-percentage-hook';
import logo from "../img/logo.png";
import logoWhite from "../img/logo-white.png";

const Header = () => {
     const stripSlashes = (x) => {
        let y = x.split("/");
        let result = y[1];

        return result;   
    }

    const location = useLocation();
    const [pathname, setPathname] = useState(stripSlashes(location && location.pathname || ''));
    const { percentage } = useScrollPercentage({ windowScroll: true });

    useEffect(() => {
        setPathname(stripSlashes(location.pathname));
    }, [location]);

    return ( 
        <header 
            id="header"
            data-bg={pathname == 'contact' ? '' : 'grey'}
            className={`
                ${pathname == 'contact' ? 'transparent--fixed ' : ' '}
                ${pathname == 'contact' && percentage.vertical > 10 ? ' moove' : ' '}
            `} 
        >
            <div className="wrap-header--padding-md">
                <nav className="main-navigation">
                    <div id="logo" className="height-lg">
                        <Link className="navbar-brand" to="/">
                            <img src={pathname == 'contact' ? (percentage.vertical > 10 ? logo : logoWhite) : logo} alt="Logo" />
                        </Link>
                    </div>
                    <div id="main-menu" aria-expanded="false" role="navigation">
                        <div className="menu-holder" data-hidden="lg">
                            <ul>
                                <li>
                                    <Link to="/" className={pathname == '' ? 'active' : ''}>Home</Link>
                                </li>
                                <li>
                                    <Link to="/contact" className={pathname == 'contact' ? 'active' : ''}>Contact</Link>
                                </li>
                                <li>
                                    <a href="https://www.amazondigitaloffice.com/login">Log in</a>
                                </li>
                            </ul>
                        </div>
                        <div className="cta">
                            <a href="https://www.amazondigitaloffice.com/register" className="btn--medium--round--border">Sign up</a>
                        </div>
                        <div className="menu-button" data-visible="lg">
                            <div className="icons" id="mobile-tigger">
                                <span className="bar bar-1"></span>
                                <span className="bar bar-2"></span>
                                <span className="bar bar-3"></span>
                            </div>
                        </div>
                    </div>
                    <div id="mobile-menu" data-visible="lg" aria-expanded="false" role="navigation">
                        <div className="mobile-wrap">
                            <div className="main-links--border col-12">
                                <ul>
                                    <li>
                                        <Link to="/" className={pathname == '' ? 'active' : ''}>Home</Link>
                                    </li>
                                    <li>
                                        <Link to="/contact" className={pathname == 'contact' ? 'active' : ''}>Contact</Link>
                                    </li>
                                    <li>
                                        <a href="https://www.amazondigitaloffice.com/login">Log in</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        </header>
    );
}
 
export default Header;